import { __extends } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { playCheckboxSound } from '@wg/web2clientapi/sound';
import classNames from 'classnames';
import * as React from 'react';
import Checkbox from '../Checkbox/Checkbox.js';
import styles from './CheckboxWithLabel.module.scss.js';

var CheckboxWithLabel = (function (_super) {
    __extends(CheckboxWithLabel, _super);
    function CheckboxWithLabel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isChecked: _this.props.isChecked,
        };
        _this.onClick = function (_) {
            _this.onChange(!_this.props.isChecked);
        };
        _this.onChange = function (value) {
            if (_this.props.isDisabled) {
                return;
            }
            playCheckboxSound();
            _this.setState({
                isChecked: !(_this.props.isChecked || _this.state.isChecked),
            });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }
    CheckboxWithLabel.prototype.render = function () {
        var _a, _b;
        var isChecked = this.props.isChecked !== undefined && this.props.isChecked !== null
            ? this.props.isChecked
            : this.state.isChecked;
        var isDisabled = this.props.isDisabled;
        return (jsxs("div", { className: classNames(styles.container, (_a = {},
                _a[styles.isDisabled] = isDisabled,
                _a)), onClick: this.onClick, children: [jsx(Checkbox, { onChange: this.onChange, isChecked: isChecked, isDisabled: isDisabled }), jsx("span", { className: classNames(styles.checkboxLabel, (_b = {},
                        _b[styles.checked] = isChecked && !isDisabled,
                        _b), this.props.className), children: this.props.labelText })] }));
    };
    return CheckboxWithLabel;
}(React.PureComponent));

export { CheckboxWithLabel as default };
//# sourceMappingURL=CheckboxWithLabel.js.map
